import { ContinueBtn } from "./Components/CalculatorBlock/ContinueBtn";
import { ClientForm } from "./Components/CalculatorBlock/ClientForm";
import { Clients } from "./Components/CalculatorBlock/Clients";
import { Country } from "./Components/CalculatorBlock/Country";
import { Covid } from "./Components/CalculatorBlock/Covid";
import { Currency } from "./Components/CalculatorBlock/Currency";
import { EndContract } from "./Components/CalculatorBlock/EndContract";
import { Multivisa } from "./Components/CalculatorBlock/Multivisa";
import { Risk } from "./Components/CalculatorBlock/Risk";
import { StartContract } from "./Components/CalculatorBlock/StartContract";
import { TravelDays } from "./Components/CalculatorBlock/TravelDays";
import 'air-datepicker/air-datepicker.css';

class TravelCalculator {
    constructor() {
        this.$insuranceForm = $('#insurance_app .calculator_form');

        this._state = {
            country: null,
            currency: 'eur',
            days: 1,
            is_multivisa: 0,
            start: null,
            end: null,
            risk: 0,
            people_count: 0,
            covid_plus: 0,
            clients: [],
            tariff: null,
            packages: [],
            selectedPackage: null,
        };

        this._init();
    }

    _init() {
        this._currency = new Currency({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._country = new Country({
            insuranceForm: this.$insuranceForm,
            state: this._state,
            currency: this._currency,
        });

        this._travelDays = new TravelDays({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._multivisa = new Multivisa({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._startContract = new StartContract({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._endContract = new EndContract({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._risk = new Risk({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._covid = new Covid({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });

        this._clientForm = new ClientForm({
            lang: this._lang,
        });

        this._clients = new Clients({
            insuranceForm: this.$insuranceForm,
            clientForm: this._clientForm,
            state: this._state,
        });

        this._continueBtn = new ContinueBtn({
            insuranceForm: this.$insuranceForm,
            state: this._state,
        });
        
    }
}

$(() => {
    new TravelCalculator();
});
